export function PinningHeader() {
  return (
    <div className="flex w-full shrink-0 flex-col bg-white p-4 shadow-sm">
      <h2 className="text-lg font-semibold text-gray-800">Request design changes</h2>
      <p className="text-xs text-amber-700">Note: Design requests are made on the original image</p>
    </div>
  );
}
